'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styling = require('@rexlabs/styling');

var _customPropTypes = require('../utils/custom-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectValue = (_dec = (0, _styling.styled)((0, _styling.StyleSheet)({
  container: { backgroundColor: 'transparent' }
})), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SelectValue, _Component);

  function SelectValue() {
    (0, _classCallCheck3.default)(this, SelectValue);
    return (0, _possibleConstructorReturn3.default)(this, (SelectValue.__proto__ || (0, _getPrototypeOf2.default)(SelectValue)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectValue, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          styles = _props.styles,
          option = _props.option,
          pluckLabel = _props.pluckLabel;

      return _react2.default.createElement(
        'span',
        styles('container'),
        pluckLabel(option)
      );
    }
  }]);
  return SelectValue;
}(_react.Component)) || _class);
process.env.NODE_ENV !== "production" ? SelectValue.propTypes = {
  styles: _propTypes2.default.func,
  /** The data to display. */
  option: _customPropTypes.OptionPropType.isRequired,
  /** The helper for getting the 'label prop' from option. */
  pluckLabel: _propTypes2.default.func.isRequired
} : void 0;
exports.default = SelectValue;